import blueMarbleJpg from '@public/img/wallpaper/blue-marble.jpg';
import cspocJpg from '@public/img/wallpaper/cspoc.jpg';
import cspoc2Jpg from '@public/img/wallpaper/cspoc2.jpg';
import epfl1Jpg from '@public/img/wallpaper/epfl-1.jpg';
import epfl2Jpg from '@public/img/wallpaper/epfl-2.jpg';
import marsJpg from '@public/img/wallpaper/mars.jpg';
import moonJpg from '@public/img/wallpaper/moon.jpg';
import opsJpg from '@public/img/wallpaper/ops.jpg';
import ops2Jpg from '@public/img/wallpaper/ops2.jpg';
import ops3Jpg from '@public/img/wallpaper/ops3.jpg';
import ops4Jpg from '@public/img/wallpaper/ops4.jpg';
import ops5Jpg from '@public/img/wallpaper/ops5.jpg';
import rocketJpg from '@public/img/wallpaper/rocket.jpg';
import rocket2Jpg from '@public/img/wallpaper/rocket2.jpg';
import rocket3Jpg from '@public/img/wallpaper/rocket3.jpg';
import rocket4Jpg from '@public/img/wallpaper/rocket4.jpg';
import thuleJpg from '@public/img/wallpaper/thule.jpg';

export const wallpapers: string[] = [
  cspocJpg,
  cspoc2Jpg,
  blueMarbleJpg,
  moonJpg,
  thuleJpg,
  rocketJpg,
  rocket2Jpg,
  rocket3Jpg,
  rocket4Jpg,
  epfl1Jpg,
  epfl2Jpg,
  opsJpg,
  ops2Jpg,
  ops3Jpg,
  ops4Jpg,
  ops5Jpg,
  marsJpg,
];
